var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("viewForm", {
    ref: "viewForm",
    attrs: { "is-edit": false, "is-customer": "" },
    on: { submit: _vm.submit },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }